// ProtectedRoute.tsx
import { Navigate } from 'react-router-dom';
import type { ReactElement } from 'react';
import { useAuth } from './AuthContext';
import Spinner from './shared/Spinner';

interface ProtectedRouteProps {
  children: ReactElement;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, isInitializing } = useAuth();
  // Avoid redirecting while auth state is initializing (rehydrating from storage)
  if (isInitializing) {
    return (
      <div className="container py-5">
        <Spinner visible ariaLabel="Initializing session" text="Initializing session…" />
      </div>
    );
  }
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};
